const firebaseConfig = {
  apiKey: "AIzaSyD5EVMtNWOlXTDQ-5oPIe7lGTWO-s6EkLk",
  authDomain: "crative-agency-0.firebaseapp.com",
  databaseURL: "https://crative-agency-0.firebaseio.com",
  projectId: "crative-agency-0",
  storageBucket: "crative-agency-0.appspot.com",
  messagingSenderId: "862131044081",
  appId: "1:862131044081:web:e81b876eca7c7c2833b350"
};

export default firebaseConfig;